import script from "./tab-2.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-2.vue?vue&type=script&setup=true&lang=js"

import "./tab-2.vue?vue&type=style&index=0&id=0aa8ea7e&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa8ea7e"]])

export default __exports__